/* eslint-disable no-param-reassign */

import moment from 'moment';
import Vue from 'vue';
import Vuex from 'vuex';

import { defaultOnNaN, withUnit } from './storeHelpers';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    title: 'Example Book',
    startProgress: 0,
    endProgress: 100,
    unit: 'percent',
    startDate: moment().toDate(),
    dueDate: moment().add(1, 'weeks').toDate(),
  },
  getters: {
    startProgress: state => defaultOnNaN(state.startProgress, 0),
    startProgressDisplay: (state, getters) => withUnit(getters.startProgress, state.unit),
    endProgress: state => defaultOnNaN(state.endProgress, 100),
    endProgressDisplay: (state, getters) => withUnit(getters.endProgress, state.unit),
  },
  mutations: {
    setTitle(state, title) {
      state.title = title;
    },
    setStartProgress(state, value) {
      state.startProgress = value;
    },
    setEndProgress(state, value) {
      state.endProgress = value;
    },
    setUnit(state, value) {
      state.unit = value;
    },
    setStartDate(state, value) {
      state.startDate = value;
    },
    setDueDate(state, value) {
      state.dueDate = value;
    },
  },
  actions: {
    setUnit({ commit, state }, value) {
      const allowedUnits = ['percent', 'pages'];

      if (!allowedUnits.includes(value)) {
        throw Error(`unit can only be one of ${allowedUnits}`);
      }

      commit('setUnit', value);

      if (state.unit === 'percent' && state.endProgress > 100) {
        commit('setEndProgress', 100);
      }
    },
  },
});
